import React from 'react'
import OfficesTree from '../Offices/OfficesTree'

const OfficeFilter = ({setOfficeFilter, setOfficeName}) => {

  const handleClickOfficeName = office => {
    setOfficeName(office.displayName)
    setOfficeFilter(prev => (office.id === prev ? '' : office.id))
  }

  return (
    <OfficesTree onClick={handleClickOfficeName} isClickable={() => true} />
  )
}

export default OfficeFilter
